import {
  useState, useEffect, useCallback, FC,
} from 'react';
import { Result } from 'antd';
import ReactPlayer from 'react-player';

import TaggedModal from '@components/TaggedModal';
import { downloadAs } from '@utils/utils';

interface PreviewModalProps {
  closeModal: () => void;
  showModal: boolean;
  filename?: string;
  data?: Blob;
  dataUrl?: string;
  mimeType?: string;
}

const PreviewModal: FC<PreviewModalProps> = (props) => {
  const {
    data, dataUrl, filename, closeModal, mimeType, showModal,
  } = props;

  const [modalWidth, setModalWidth] = useState<string | number>(600);
  const isVideo = mimeType ? mimeType.includes('video/') : false;
  const isImage = mimeType ? mimeType.includes('image/') : false;

  useEffect(() => {
    if (isVideo || isImage) {
      setModalWidth('max-content');
    }
  }, [isVideo, isImage]);

  const renderPreviewer = useCallback(() => {
    if (isVideo) {
      return <ReactPlayer url={dataUrl} controls data-testid="react-player" />;
    }
    if (isImage) {
      return <img alt={filename} src={dataUrl} className="w-full" data-testid="preview-media-image" />;
    }
    return <Result status="error" title="Unable to preview media" />;
  }, [dataUrl]);

  const handleDownload = () => {
    if (data && filename && mimeType) {
      downloadAs(data, filename, mimeType);
    }
  };

  return (
    <TaggedModal
      tag="previewModal"
      visible={showModal}
      title={filename}
      onCancel={closeModal}
      destroyOnClose
      width={modalWidth}
      okText="Download Media"
      cancelText="Close"
      onOk={handleDownload}
    >
      {renderPreviewer()}
    </TaggedModal>
  );
};

export default PreviewModal;
